import { render } from "./ReturnTerms.vue?vue&type=template&id=4b853198"
import script from "./ReturnTerms.vue?vue&type=script&setup=true&lang=js"
export * from "./ReturnTerms.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/returnTerms/ReturnTerms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b853198"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b853198', __exports__)) {
    console.log('reload')
    api.reload('4b853198', __exports__)
  }
  
  module.hot.accept("./ReturnTerms.vue?vue&type=template&id=4b853198", () => {
    console.log('re-render')
    api.rerender('4b853198', render)
  })

}


export default __exports__